const swiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,
  centeredSlides: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false
  },
  speed: 3000,
  slidesPerView: 1.5,
  spaceBetween: 20,
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
  effect: 'coverflow',
  coverflowEffect: {
    rotate: 0,
    stretch: 0, // Space between slides
    depth: 250, // Perspective depth (makes side slides look smaller)
    modifier: 1.5, // Effect multiplier
    slideShadows: false, // Set to true for shadows
  },
});
